<template>
    <b-card no-body>
        <b-card-header>
            <i class="icon-note"></i>
            <strong>{{ $t('form.create', { item: 'comentário' }) }}</strong>
        </b-card-header>
        <b-card-body>
            <Form :isSubmitting="isSubmitting" @onSubmit="onSubmit" />
        </b-card-body>
    </b-card>
</template>

<script>
import Form from './components/Form'
import api from '@/services/api'
import { success, danger } from '@/lib/notification'
import i18n from '@/i18n'
import { mapperGeneralCommentToApi } from './mappers/mapperGeneralCommentToApi'

const initialValues = {
    comment: null,
}

export default {
    name: 'New',
    components: {
        Form,
    },
    data() {
        return {
            isSubmitting: false,
            form: Object.assign({}, initialValues),
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        onSubmit(form, onReset, isLoading) {
            isLoading(true)
            api.post(
                '/general-comment',
                mapperGeneralCommentToApi(form, this.$route.query.userId)
            )
                .then(() => {
                    onReset()
                    this.notificationGeneralCommentCreatedSuccessfully()
                    this.goBack()
                })
                .catch(e => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationGeneralCommentCreatedSuccessfully() {
            success(
                i18n.t('notification.createdSuccessfully', {
                    item: i18n.t('generalComment.comment'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>
